import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../shared/services/auth.service';
import { PopupService } from 'app/shared/services/pop-up.service';
import { LayoutService } from '../../shared/services/layout.service';
import { ErrorService } from '../../shared/services/error.service';
import { STATIC_VALUE } from '../../shared/configuration/static.value';
import { EncryptionService } from 'app/shared/services/encryption.service';

@Component({
    selector: 'login-login',
    templateUrl: 'login.component.html'
})

export class LoginLoginComponent {
    vEmail: string;
    vPassword: string;
    PopUpFlag: string;
    fileContent: string;

    constructor(
        private _layoutService: LayoutService,
        private _errorService: ErrorService,
        private _authService: AuthService,
        private _popupService: PopupService,
        private _encryptionService: EncryptionService
    ) {

    }

    ngOnInit() {
        this._layoutService.setCurrentPage('login-login');
        this._authService.resetError();
        console.log("Decrypt Answer")
        console.log(this._encryptionService.decrypt("U2FsdGVkX1+Zg1IsYfovS26go7uxwuLfKMFAraJKteI="))
        //this.TermsAndConditions(); //Kowsalya
    }

    getErrorStatusAndMessage() {
        return this._errorService.getErrorStatusAndMessage();
    }

    getBackEndError() {
        return this._errorService.getBackEndError();
    }

    isDisableClick() {
        return (this.vEmail === undefined || this.vEmail === '') || (this.vPassword === undefined || this.vPassword === '') ? true : false;
    }

    getLoadingStatus() {
        return this._authService.getLoadingStatus();
    }

    login() {
        this._authService.checkLogin(this.vEmail, this.vPassword);
    }
    Contactus() {
        return STATIC_VALUE.CONTACTUS;
    }


}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/login.component.ts